<template>
    <div>
        <b-modal
                id="uae-pass-confirmation-popup"
                ref="modal"
                :title="title"
                size="sm"
                hide-footer
                modal-class="hide-footer"
                no-close-on-backdrop
                no-close-on-esc
                hide-header-close=true
        >
            <div style="text-align: center">
                <p
                        style="padding: 10px 30px ; font-size: 14px; color: #424141;"
                >
                    {{ description }}
                </p>
                <!--<img style="width: 100%" src="../../assets/images/UAEPASS_Login05.svg" />-->
                <a class="temp-btn" @click="onConfirmPopup">
                    <img src="../../assets/images/UAEPASS_Sign_up.png" />
                    <!--Sign In with UAE PASS-->
                </a>
                <div v-if="isUaePassValue == true">

            
                <div class="divider">
                    <span class="divider-text">OR</span>
                </div>
                <div class="action-buttons">
                    <b-button
                            type="button"
                            variant="primary"
                            class="primary-add-btn"
                            @click="onCancelPopup"
                            :disabled = "loading"
                    >
                        <span class="btn-text">{{ cancelText }}</span>
                        <span class="loader"></span>
                    </b-button>
                </div>
            </div>

            </div>

        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    // import Multiselect from 'vue-multiselect'
    // import _ from "lodash";
    // import resource from "@/api/resource";

    import request from '@/utils/request'

    // const roleApi = new resource("access-control/roles");
    // const dataSegmentApi = new resource("access-control/data-segments");

    export default {
        components: {
            // Multiselect,
        },

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            redirectUrl:{
                type:String,
                default:null
            },
            title:{
                type:String,
                default: 'Confirmation',
            },
            description:{
                type:String,
                default: 'Are you sure, You want to Resend Email?',
            },
            confirmText: {
                type: String,
                default: 'Yes',
            },
            cancelText: {
                type: String,
                default: 'Cancel',
            },
            onConfirm:{
                type:Function,
                default: ()=>{}
            },
            onCancel:{
                type:Function,
                default: ()=>{}
            },
            isUaePassValue:{
                type: Boolean,
                default: false,
            }
        }, // End of Component > props
        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */

        data() {
            return {
            };
        },
        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters(["loading", "selectedItem","dataSegmentId"]),

        }, // End of Component > computed
        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {
        }, // End of Component > watch

        mounted() {

            console.log("this",this.selectedItem)
            
        },
        methods: {
            async onConfirmPopup(){
                if(this.redirectUrl)
                {
                    window.location.assign(this.redirectUrl)
                }
                await this.onConfirm()
                this.$bvModal.hide('uae-pass-popup')
            },
            async onCancelPopup() {
                await this.onCancel();
                this.$bvModal.hide('uae-pass-popup')
            },
        }
    };
</script>
<style>
    .temp-btn
    {
        justify-content: center;
        height: 70px;
        text-align: center;
        display: flex;
        width: 100%;
        /*background: white !important;*/
        /*color: purple !important;*/
        /*border: 1px solid purple !important;*/
        text-decoration: none !important;
        padding: 10px !important;
    }
    .divider {
        border-bottom: none !important;
        display: flex;
        align-items: center;
        text-align: center;
        margin: 20px 0;
    }

    .divider::before,
    .divider::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid #000;
    }

    .divider-text {
        padding: 0 10px;
    }
</style>
